import React, { ReactNode, useLayoutEffect } from 'react'
import './App.css'
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom'
import { EMenu } from './components/screens/tracking/type'
import { NavbarTemplate } from './components/templates/NavbarTemplate'
import { MenuTemplate } from './components/templates/MenuTemplate'
import { SearchScreen } from './components/screens/search/SearchScreen'
import { TrackingScreen } from './components/screens/tracking/TrackingScreen'
import { NotfoundScreen } from './components/screens/notfound/NotfoundScreen'
import { ReturnRequestScreen } from './components/screens/reqReturn/ReturnRequestScreen'
import { PickupLocationScreen } from './components/screens/pickupLocation/PickupLocationScreen'
import { ReturnPlace } from './components/screens/placeReturn/ReturnPlace'
import { ExchangePlace } from './components/screens/placeExchange/ExchangePlace'
import { EntranceInfoScreen } from './components/screens/entranceInfo/EntranceInfoScreen'
import { debounce } from './common/fns'

declare global {
  interface Window {
    Cypress: any
    initialState: any
    install: any
    installed: boolean
  }
}

if (process.env.NODE_ENV === 'production') {
  console.log = function no_console() {}
}
const ScrollTopWrapper = ({ children }: { children: ReactNode }) => {
  const location = useLocation()

  useLayoutEffect(() => {
    // Scroll to the top of the page when the route changes
    document.body.scrollTop = 0;
  }, [location.pathname])

  return children
}

function App() {
  const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }

  window.addEventListener('resize', debounce(appHeight))
  appHeight()

  return (
    <Router>
      <ScrollTopWrapper>
        <Routes>
          <Route path="/" element={<NavbarTemplate />}>
            <Route path="/" element={<SearchScreen />} />
            <Route path="/tracking/:tracking/" element={<MenuTemplate />}>
              <Route path={''} element={<TrackingScreen />} />
              <Route path={'tracking'} element={<TrackingScreen />} />
              <Route path={EMenu.reqReturn} element={<ReturnRequestScreen />} />
              <Route path={EMenu.return} element={<ReturnPlace />} />
              <Route path={EMenu.info} element={<PickupLocationScreen />} />
              <Route path={EMenu.exchange} element={<ExchangePlace />} />
              <Route path={EMenu.entrance} element={<EntranceInfoScreen />} />
            </Route>
          </Route>
          <Route path="*" element={<NotfoundScreen />} />
        </Routes>
      </ScrollTopWrapper>
    </Router>
  )
}

export default App
